import { render, staticRenderFns } from "./CustAddMain.vue?vue&type=template&id=3e486941&scoped=true&"
import script from "./CustAddMain.vue?vue&type=script&lang=js&"
export * from "./CustAddMain.vue?vue&type=script&lang=js&"
import style0 from "./CustAddMain.vue?vue&type=style&index=0&id=3e486941&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e486941",
  null
  
)

export default component.exports